import Joyride, { CallBackProps, Step } from 'react-joyride';

import { CustomTooltip } from './CustomTooltip';

interface TourRendererProps {
  steps: Step[];
  run: boolean;
  stepIndex: number;
  onCallback: (data: CallBackProps) => void;
}

export const TourRenderer = ({
  steps,
  run,
  stepIndex,
  onCallback,
}: TourRendererProps) => {
  if (!steps.length) return null;

  return (
    <Joyride
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      callback={onCallback}
      continuous={true}
      showProgress={false}
      showSkipButton={false}
      disableOverlayClose={false}
      disableCloseOnEsc={false}
      hideCloseButton={false}
      tooltipComponent={CustomTooltip}
      floaterProps={{
        disableAnimation: true,
      }}
      styles={{
        options: {
          arrowColor: '#ffffff',
          backgroundColor: '#ffffff',
          overlayColor: 'rgba(0, 0, 0, 0.5)',
          primaryColor: '#3b82f6',
          textColor: '#333',
          zIndex: 1000,
        },
      }}
    />
  );
};
